import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import Layout from './components/Layout/Layout';
import AppRoutes from './AppRoutes';
import { GlobalStyle } from './styles/globalStyles';
import { darkTheme, lightTheme } from './styles/theme';

import { ThemeProvider as MaterialThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

export const ThemeContext = React.createContext(null);

const darkMaterialTheme = createTheme({
  palette: {
    mode: 'dark',
    secondary: {
        main: '#878fa6'
    }
  },
  components: {

    MuiTableBody: {
        styleOverrides: {
            root: {
                '& :hover > td': {
                    backgroundColor: '#878fa6 !important',
                },
            }
        }
    },

    // MuiTableRow: {
    //     styleOverrides: {
    //         root: {
    //             '& :hover': {
    //                 backgroundColor: '#878fa6 !important',
    //             },
    //             fontWeight: 'bold',
    //         }
    //     }
    // },

    // MuiTableCell: {
    //   styleOverrides: {
    //       //   hover: {
    //       //     color: 'red',
    //       //     backgroundColor: '#878fa6 !important',
    //       //   },
    //       root: {
    //         fontWeight: 'bold',
    //         ':hover': {
    //             backgroundColor: '#878fa6 !important'
    //         }
    //         // color: 'red',
    //         // backgroundColor: '#878fa6 !important',
    //       },
    //   },
    // },
  },
});

const App = () => {
  const [theme, setTheme] = useState('dark');
  const themeStyle = theme === 'light' ? lightTheme : darkTheme;

  return (
    <ThemeContext.Provider value={{ setTheme, theme }}>
      <ThemeProvider theme={themeStyle}>
        <GlobalStyle />
        <Helmet>
          <title>Club Ajedrez Pensado</title>
          <link rel='preconnect' href='https://fonts.googleapis.com' />
          <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
          <link
            href='https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400..700;1,400..700&family=Roboto:wght@400;500;700&display=swap'
            rel='stylesheet'
          />
        </Helmet>
        <>
          <Layout>
            <MaterialThemeProvider theme={darkMaterialTheme}>
              <CssBaseline />
              <AppRoutes />
            </MaterialThemeProvider>
          </Layout>
        </>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;
